import { RouteObject } from 'react-router-dom';
import { PermissionView } from 'shared/modules/permission/core/PermissionView';
import { useUserRedirect } from './data/UserStore';
import { useEffect } from 'react';
import { lazyImport } from 'shared/routing/LazyRoute';

const UsersPage = lazyImport(() => import('./UsersPage'), 'UsersPage');

export function UsersPageContainer() {
  const { handleUserRedirect } = useUserRedirect();

  useEffect(() => {
    return () => {
      handleUserRedirect(true);
    };
  }, [handleUserRedirect]);

  return (
    <PermissionView name="users" permission="can_view">
      <UsersPage />
    </PermissionView>
  );
}

export const usersPageRoutes: RouteObject[] = [
  { path: 'users/:guid?/:action?', element: <UsersPageContainer /> },
];
